import { Link } from 'react-router-dom'
import { XCircle } from 'lucide-react'
import { AuthLayout } from '@/modules/auth/ui/components'
import { Button } from '@/shared/ui/primitives'

export type InvalidStateProps = {
  message: string
}

export function InvalidState({ message }: InvalidStateProps) {
  return (
    <AuthLayout title="Invitation link not valid" subtitle={message}>
      <div className="flex flex-col gap-4">
        <div className="flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
            <XCircle className="h-8 w-8 text-destructive" aria-hidden />
          </div>
        </div>
        <div className="flex flex-col gap-2 text-sm text-muted-foreground">
          <p>This can happen if:</p>
          <ul className="ml-5 list-disc">
            <li>The link has already been used</li>
            <li>The link was copied incorrectly</li>
            <li>The organization no longer exists</li>
          </ul>
        </div>
        <Button asChild variant="default" className="w-full">
          <Link to="/sign-in">Go to sign in</Link>
        </Button>
      </div>
    </AuthLayout>
  )
}
